<script setup lang="ts">
import {useModal} from "@/shared/composables/useModal.ts";
import ModalComponent from "@/shared/components/ModalComponent.vue";

const {state, hideModal} = useModal();

const onClose = () => {
  hideModal();
};
</script>

<template>
  <Teleport to="body">
    <ModalComponent
      v-if="state.visible && state.component"
      :open="state.visible"
      v-bind="state.props"
      @close="onClose"
    >
      <template #default="{ close }">
        <component
          :is="state.component"
          v-bind="state.props"
          :close="() => { close(); onClose(); }"
        />
      </template>
    </ModalComponent>
  </Teleport>
</template>
